import { useEffect, useState } from "react";
import styles from "../HealthChat.module.css";

const STEPS = [
  "Analyzing your symptoms...",
  "Checking the information you've provided...",
  "Finding the best care options for you...",
];

export default function TriageScreen({ onComplete, onBack }) {
  const [step, setStep] = useState(0);

  useEffect(() => {
    const intervals = STEPS.map((_, i) =>
      setTimeout(() => setStep(i), i * 1200),
    );
    const done = setTimeout(onComplete, STEPS.length * 1200 + 600);
    return () => {
      intervals.forEach(clearTimeout);
      clearTimeout(done);
    };
  }, [onComplete]);

  return (
    <div className={styles.triageScreen}>
      <button className={styles.selectDoctorBack} onClick={onBack}>
        ← Back
      </button>
      <div className={styles.triageScreenBody}>
        <div className={styles.triageTitle}>Triage in Progress</div>

        {/* Animated heart ring */}
        <div className={styles.triageRingWrap}>
          <div className={styles.triageRing}>
            {[...Array(8)].map((_, i) => (
              <div
                key={i}
                className={styles.triageDot}
                style={{
                  transform: `rotate(${i * 45}deg) translateY(-38px)`,
                  animationDelay: `${i * 0.15}s`,
                }}
              />
            ))}
            <div className={styles.triageHeart}>
              <svg width="44" height="44" viewBox="0 0 24 24" fill="none">
                <path
                  d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l7.78-7.78a5.5 5.5 0 0 0 0-7.78z"
                  fill="#4A148C"
                />
                <polyline
                  points="7,13 10,16 17,9"
                  stroke="#fff"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  fill="none"
                />
              </svg>
            </div>
          </div>
        </div>

        <div className={styles.triageSteps}>
          {STEPS.map((s, i) => (
            <div
              key={i}
              className={`${styles.triageStep} ${i <= step ? styles.triageStepActive : ""}`}
            >
              {s}
            </div>
          ))}
        </div>

        <div className={styles.triageHint}>
          This should only take a moment. Thank you for your patience.
        </div>
      </div>
    </div>
  );
}
